/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Tooltip_Open_UrlInputs */

const es_settings_dirs_tooltip_open_url = /** @type {(inputs: Settings_Dirs_Tooltip_Open_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir en proveedor`)
};

const en_settings_dirs_tooltip_open_url = /** @type {(inputs: Settings_Dirs_Tooltip_Open_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in provider`)
};

/**
* | output |
* | --- |
* | "Open in provider" |
*
* @param {Settings_Dirs_Tooltip_Open_UrlInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_tooltip_open_url = /** @type {((inputs?: Settings_Dirs_Tooltip_Open_UrlInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Tooltip_Open_UrlInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_tooltip_open_url(inputs)
	return en_settings_dirs_tooltip_open_url(inputs)
});
export { settings_dirs_tooltip_open_url as "settings.dirs.tooltip.open_url" }